//
// SupportedType.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../TransportModel";

var SupportedType = createModule("transport::SupportedType", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        supportsReportLevelComments: 2,
        name: 7,
        supportsPrinting: 2,
        supportsObjectLevelComments: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default SupportedType;
